<template>
  <div class="buy-set-content pl16 pr16" v-loading="loading">
    <el-form ref="form1" :model="setForm" label-width="180px" size="small">
      <!--通信设置-->
      <div class="common-form">通信设置</div>
      <el-form-item label="最后一次读取时间：">
        {{ parseTime(timestamp_protocol) }}
      </el-form-item>

      <el-form-item label="上传间隔："
                    :rules="[{ required: true, message: '上传间隔不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_HEART_PERIOD">
        <el-input type="number" v-model="setForm.PROTOCOL.PROTOCOL_HEART_PERIOD" placeholder="请输入排序"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="设备协议：" :rules="[{ required: true, message: '设备协议不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_SELECTED_ITEM">
        <el-radio-group v-model="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM">
          <el-radio :label="'0'">RS232</el-radio>
          <el-radio :label="'1'">RS485</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="RS232协议：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '0'"
                    :rules="[{ required: true, message: 'RS232协议不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_232_PRODUCT">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_232_PRODUCT" placeholder="请选择协议" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.RS232_PROTOCOL)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="波特率：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '0'"
                    :rules="[{ required: true, message: '波特率不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_232_BAUDRATE">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_232_BAUDRATE" placeholder="请选择波特率" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.BAUD_RATE)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>

      <el-form-item label="RS485协议：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '1'"
                    :rules="[{ required: true, message: 'RS485协议不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_485_PRODUCT">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_485_PRODUCT" placeholder="请选择协议" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.RS485_PROTOCOL)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="主从机：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '1'"
                    :rules="[{ required: true, message: '主从机不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_485_MASTER_SLAVE">
        <el-radio-group v-model="setForm.PROTOCOL.PROTOCOL_485_MASTER_SLAVE">
          <el-radio v-for="dict in this.getDictDatas(DICT_TYPE.PROTOCOL_485_MASTER_SLAVE)"
                    :key="dict.value" :label="dict.value">{{ dict.label }}
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="波特率：" v-if="setForm.PROTOCOL.PROTOCOL_SELECTED_ITEM === '1'"
                    :rules="[{ required: true, message: '波特率不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_485_BAUDRATE">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_485_BAUDRATE" placeholder="请选择波特率" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.BAUD_RATE)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>

      <!--大屏设置-->
      <div class="common-form">大屏设置</div>
      <el-form-item label="大屏协议：" :rules="[{ required: true, message: '大屏协议不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_BIG_SCREEN_PRODUCT">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_BIG_SCREEN_PRODUCT" placeholder="请选择波特率" clearable
                   size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.PROTOCOL_BIG_SCREEN)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
      <el-form-item label="大屏波特率："
                    :rules="[{ required: true, message: '大屏波特率不能为空' }]"
                    prop="PROTOCOL.PROTOCOL_BIG_SCREEN_BAUDRATE">
        <el-select v-model="setForm.PROTOCOL.PROTOCOL_BIG_SCREEN_BAUDRATE" placeholder="请选择大屏波特率" clearable
                   size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.BAUD_RATE)"
                     :key="dict.value" :label="dict.label" :value="dict.value"/>
        </el-select>
      </el-form-item>
    </el-form>

    <el-form ref="form2" :model="setForm" label-width="180px" size="small">
      <!--系统参数设置-->
      <div class="common-form">系统参数设置</div>
      <el-form-item label="最后一次读取时间：">
        {{ parseTime(timestamp_sys) }}
      </el-form-item>
      <el-form-item label="打印结束空行："
                    prop="PROTOCOL.PROTOCOL_HEART_PERIOD">
        <el-input type="number" v-model="setForm.SYS.SYS_PRINT_END_LINE" placeholder="打印结束空行"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="重量变化上限(千克)："
                    prop="PROTOCOL.PROTOCOL_HEART_PERIOD">
        <el-input type="number" v-model="setForm.SYS.SYS_FLUCTUATION_THRESHOLD" placeholder="重量变化上限"
                  class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="有效显示时间(秒)："
                    prop="PROTOCOL.PROTOCOL_HEART_PERIOD">
        <el-input type="number" v-model="setForm.SYS.SYS_DISPLAY_TIME" placeholder="有效显示时间"
                  class="max-w460"></el-input>
      </el-form-item>

      <div class="common-button-wrapper">
        <el-button icon="el-icon-refresh" size="small" type="info" @click="refreshFunction">立即刷新</el-button>
        <el-button icon="el-icon-files" size="small" type="primary" @click="saveFunction">立即保存</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';
import {map} from 'lodash-es';

export default {
  data() {
    return {
      formRules: {},
      timestamp_protocol: 0,
      timestamp_sys: 0,
      setForm: {
        PROTOCOL: {
          PROTOCOL_232_PRODUCT: '0',
          PROTOCOL_232_BAUDRATE: '9600',
          PROTOCOL_485_PRODUCT: '0',
          PROTOCOL_485_BAUDRATE: '9600',
          PROTOCOL_485_MASTER_SLAVE: 1,
          PROTOCOL_485_ADDRESS: '0',
          PROTOCOL_232_ADDRESS: '0',
          PROTOCOL_HEART_PERIOD: '0',
          PROTOCOL_SELECTED_ITEM: '0',
          PROTOCOL_BIG_SCREEN_PRODUCT: '0',
          PROTOCOL_BIG_SCREEN_BAUDRATE: '9600',
        },
        SYS: {
          SYS_PRINT_END_LINE: '0',
          SYS_FLUCTUATION_THRESHOLD: '200',
          SYS_DISPLAY_TIME: '60',
        }
      },
      /*是否正在加载*/
      loading: false,
    };
  },
  created() {
    let self = this;
    self.refreshFunction();
  },
  inject: ['form'],
  methods: {
    onItemChange(value) {
      this.PROTOCOL.PROTOCOL_SELECTED_ITEM = value
    },
    refreshFunction() {
      let self = this;
      self.loading = true;
      self.queue([self.readPROTOCOLFunction, self.readSYSFunction])
        .then(result => {
          self.loading = false;
          for (let data of result) {
            if (data.success) {
              self.$message.success(data.msg);
            } else {
              self.$message.error(data.msg);
            }
          }
        });
    },
    saveFunction() {
      let self = this;
      self.loading = true;
      self.queue([self.savePROTOCOLFunction, self.saveSYSFunction])
        .then(result => {
          self.loading = false;
          for (let data of result) {
            if (data.success) {
              self.$message.success(data.msg);
            } else {
              self.$message.error(data.msg);
            }
          }
        });
    },
    async queue(promiseArr) {
      var res = []
      for (let fun of promiseArr) {
        var resData = await fun()
        res.push(resData)
      }
      return res;
    },
    readPROTOCOLFunction() {
      let self = this;
      return new Promise((resolve, reject) => {
        PorductApi.invokeFunction({
          id: self.form.model.id,
          functionId: '$WB_READ',
          convert: true,
          query: {
            "type": Object.keys(this.setForm.PROTOCOL).join(',')
          },
        }, true)
          .then(res => {
            const mData = res.data.split(",");
            Object.keys(self.setForm.PROTOCOL).forEach(function (item, index) {
              self.setForm.PROTOCOL[item] = mData[index]
            })
            self.timestamp_protocol = res.timestamp
            resolve({msg: '读取通讯参数成功', data: res, success: true})
          })
          .catch(error => {
            resolve({msg: '读取通讯参数失败', success: false});
          });
      });
    },
    readSYSFunction() {
      let self = this;
      return new Promise((resolve, reject) => {
        PorductApi.invokeFunction({
          id: self.form.model.id,
          functionId: '$WB_READ',
          convert: true,
          query: {
            "type": Object.keys(this.setForm.SYS).join(',')
          },
        }, true)
          .then(res => {
            const mData = res.data.split(",");
            Object.keys(self.setForm.SYS).forEach(function (item, index) {
              self.setForm.SYS[item] = mData[index]
            })
            self.timestamp_sys = res.timestamp
            resolve({msg: '读取系统参数成功', data: res, success: true})
          })
          .catch(error => {
            resolve({msg: '读取系统参数失败', success: false});
          });
      });
    },
    savePROTOCOLFunction() {
      let self = this;
      return new Promise((resolve, reject) => {
        self.$refs.form1.validate(valid => {
          if (valid) {
            PorductApi.invokeFunction({
              id: self.form.model.id,
              functionId: '$WB_WRITE',
              convert: true,
              query: {
                "type": Object.keys(self.setForm.PROTOCOL).join(','),
                "data": Object.values(self.setForm.PROTOCOL).join(',')
              }
            }, true)
              .then(res => {
                resolve({msg: '保存通讯参数成功', data: res, success: true})
              })
              .catch(error => {
                resolve({msg: '保存通讯参数失败', success: false});
              });
          } else {
            self.loading = false;
          }
        });
      });
    },
    saveSYSFunction() {
      let self = this;
      return new Promise((resolve, reject) => {
        self.$refs.form2.validate(valid => {
          if (valid) {
            PorductApi.invokeFunction({
              id: self.form.model.id,
              functionId: '$WB_WRITE',
              convert: true,
              query: {
                "type": Object.keys(self.setForm.SYS).join(','),
                "data": Object.values(self.setForm.SYS).join(',')
              }
            }, true)
              .then(res => {
                resolve({msg: '保存系统参数成功', data: res, success: true})
              })
              .catch(error => {
                resolve({msg: '保存系统参数失败', success: false});
              });
          } else {
            self.loading = false;
          }
        });
      });
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/FunctionInvoke.vue